import * as React from "react";

import FinancialDetails from "./details";
import FinancialSummary from "./summary";
import { ITransaction } from "@/types/transaction";
import MyAccordion from "../../accordion";
import { Stack } from "@mui/material";
interface IFinancialAccordionProps {
  items: ITransaction[];
}

const FinancialAccordion: React.FunctionComponent<IFinancialAccordionProps> = ({
  items,
}) => {

  const [expandedId, setExpandedId] = React.useState<number | string | null>(null);
  const [clicked, setClicled] = React.useState(false)
  const checkExpanded = (id: string) => {
    const isSameTicket = id === expandedId;
    const shouldExpand = !isSameTicket || !expandedId;

    setExpandedId(shouldExpand ? id : null);
    setClicled(!clicked || !isSameTicket);
  }

  return (
    <Stack spacing={1.5}>
      {items.map((item) => {
        return (
          <MyAccordion id={item.id} summary={<FinancialSummary item={item} />}
            expanded={(expandedId === item.id) && clicked}
            onToggleExpand={() => checkExpanded(item.id)}
          >
            <FinancialDetails item={item} />
          </MyAccordion>
        );
      })}
    </Stack>
  );
};

export default FinancialAccordion;
